import React, { Component } from 'react';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import UserSearch from '../users/UserSearch';
import UserProfilePage from '../users/UserProfilePage';
import TestAccountsPage from '../users/TestAccountsPage';
import Misc from '../misc/Misc';
import HomeBanner from '../misc/HomeBanner/HomeBanner';
import ExerciseManagementPage from '../exercises/ExerciseManagementPage';
import CreateExercisePage from '../exercises/CreateExercisePage';
import EditExercisePage from '../exercises/EditExercisePage';
import ProgramsPage from '../programs/ProgramsPage';
import ProgramDetailPage from '../programs/ProgramDetailPage';
import EditProgramPage from '../programs/EditProgramPage';

export const ROUTES = [
  { path: '/users', title: 'Users', element: <UserSearch />, includeInMenu: true },
  { path: '/users/test-accounts', title: 'Test Accounts', element: <TestAccountsPage />, includeInMenu: true },
  { path: '/users/:uid', title: 'User Profile', element: <UserProfilePage />, includeInMenu: false },
  { path: '/home-banner', title: 'Home Banner', element: <HomeBanner />, includeInMenu: true },
  { path: '/misc', title: 'Miscellaneous', element: <Misc />, includeInMenu: true },
  { path: '/exercises', title: 'Exercises', element: <ExerciseManagementPage />, includeInMenu: true },
  { path: '/exercises/new', title: 'Create Exercise', element: <CreateExercisePage />, includeInMenu: false },
  { path: '/exercises/:index/edit', title: 'Edit Exercise', element: <EditExercisePage />, includeInMenu: false },
  { path: '/programs', title: 'Programs', element: <ProgramsPage />, includeInMenu: true },
  { path: '/programs/new', title: 'Program Builder', element: <EditProgramPage />, includeInMenu: false },
  { path: '/programs/:name', title: 'Program Detail', element: <ProgramDetailPage />, includeInMenu: false },
  { path: '/programs/:name/edit', title: 'Edit Program', element: <EditProgramPage />, includeInMenu: false },
  { path: '/programs/:name/edit/week/:week', title: 'Edit Program', element: <EditProgramPage />, includeInMenu: false },
]

const drawerWidth = 240;

class AdminPageComponent extends Component {
  render() {
    return (
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            borderRight: '1px solid #e0e0e0',
            height: '100vh',
          }}
        >
          <Typography variant="h6" noWrap component="div" sx={{ p: 2 }}>
            Admin Dashboard
          </Typography>
          <List>
            {ROUTES.filter(route => route.includeInMenu).map(({ title, path }) => (
              <ListItem button key={title} component={Link} to={path} sx={{ borderBottom: '1px solid #e0e0e0', pt: '1rem', pb: '1rem' }}>
                <ListItemText primary={title} />
              </ListItem>
            ))}
          </List>
        </Box>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/users" replace />} />
            {ROUTES.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </Box>
      </Box>
    );
  }
}

export default AdminPageComponent;
